import { LegalLayout } from './LegalLayout';
import styles from './LegalLayout.module.css';

// PLACEHOLDER COPY — review with legal before production launch.
export function Terms() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="2026-04-22">
      <div className={styles.placeholder}>
        Draft — reviewed against current architecture. Requires legal sign-off before production launch.
      </div>

      <h2>1. The service</h2>
      <p>
        Markcat is a bookmark-management service provided by <strong>Danube Mechatronics Kft.</strong>
        (the "Provider"). By creating an account or using the service (the "Service") you agree to
        these Terms.
      </p>

      <h2>2. Accounts</h2>
      <ul>
        <li>You must provide a valid email address and keep your credentials secret.</li>
        <li>One account per person; shared accounts are not permitted on paid plans.</li>
        <li>You are responsible for all activity under your account.</li>
      </ul>

      <h2>3. Plans and billing</h2>
      <ul>
        <li>Free, Basic, and Pro plans are available. Current prices and limits are shown on the
          pricing page and in your Billing page.</li>
        <li>Subscriptions renew automatically until cancelled. You can cancel at any time via the
          Stripe Customer Portal — access is retained through the end of your paid period.</li>
        <li>Top-up classification credits are one-time purchases that do not expire.</li>
        <li>Prices include applicable EU VAT where required. We reserve the right to change prices
          with 30 days' notice; existing subscriptions keep their original price until renewal.</li>
      </ul>

      <h2>4. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service to store or classify content that is illegal in the EU (e.g. CSAM,
          infringing copyrighted material you do not have rights to).</li>
        <li>Abuse the crawler to scrape sites in a way that violates their terms or robots.txt.</li>
        <li>Attempt to circumvent plan limits, reverse-engineer our APIs, or interfere with other
          users' accounts.</li>
      </ul>

      <h2>5. Your content</h2>
      <p>
        You retain all rights to the bookmarks and content you save. You grant us a limited licence
        to store, index, and process them solely for the purpose of providing the Service.
      </p>

      <h2>6. Third-party LLM providers</h2>
      <p>
        Classification requires sending page title/content to an LLM provider. By using this feature
        you authorise us to transmit the content of your saved bookmarks to the provider you select
        for this purpose. You may self-host Ollama to avoid third-party transmission.
      </p>

      <h2>7. Availability</h2>
      <p>
        We aim for high availability but make no uptime guarantee on Free and Basic tiers. Planned
        maintenance will be announced in advance where practicable.
      </p>

      <h2>8. Termination</h2>
      <p>
        You may delete your account at any time from Settings → Account. We may suspend or terminate
        accounts that violate Section 4, with written notice where possible.
      </p>

      <h2>9. Disclaimer and liability</h2>
      <p>
        The Service is provided "as is". To the maximum extent permitted by law, our aggregate
        liability for any claim arising from the Service is limited to the fees you paid in the
        12 months preceding the claim. Nothing in these Terms limits liability for gross negligence,
        intent, or statutory liabilities that cannot be excluded.
      </p>

      <h2>10. Governing law</h2>
      <p>
        These Terms are governed by Hungarian law. Consumer rights under the laws of your place of
        residence remain unaffected. Disputes shall be submitted to the competent Hungarian courts
        unless mandatory consumer-protection rules designate a different forum.
      </p>

      <h2>11. Changes</h2>
      <p>
        Material changes to these Terms will be announced by email at least 14 days before they take
        effect. Continued use after that date constitutes acceptance.
      </p>

      <h2>12. Contact</h2>
      <p>
        <a href="mailto:office@danube-mechatronics.com">office@danube-mechatronics.com</a>
      </p>
    </LegalLayout>
  );
}
